export default "__VITE_ASSET__8914b260__"